import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';

const AreaSelectionLayer = ({ onAreaSelected }) => {
  const map = useMap();
  const drawHandlerRef = useRef(null);
  // Keep a stable ref so the effect doesn't re-run when the callback identity changes
  // (enrichedPositions updates every second → new handleAreaSelected every second)
  const onAreaSelectedRef = useRef(onAreaSelected);
  useEffect(() => { onAreaSelectedRef.current = onAreaSelected; });

  useEffect(() => {
    if (!map) return;

    const drawHandler = new L.Draw.Rectangle(map, {
      shapeOptions: {
        color: '#3b82f6',
        weight: 2,
        fillOpacity: 0.15,
        dashArray: '6, 4',
      },
    });
    drawHandlerRef.current = drawHandler;
    drawHandler.enable();

    const onCreated = (e) => {
      if (e.layerType !== 'rectangle') return;
      const bounds = e.layer.getBounds();
      map.removeLayer(e.layer);
      onAreaSelectedRef.current(bounds);
    };

    map.on(L.Draw.Event.CREATED, onCreated);

    return () => {
      map.off(L.Draw.Event.CREATED, onCreated);
      drawHandler.disable();
    };
  }, [map]); // intentionally excludes onAreaSelected — use the ref instead

  return null;
};

export default AreaSelectionLayer;
